import Icon from '/@/components/icon';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FieldviewAutofillIcon = () => (
    <Icon type='fieldview' size='xs' sx={{ fill: (t: any) => t.palette.primary.mui.inactive }} />
);

export default FieldviewAutofillIcon;
